import { render } from "./NeedAuth.vue?vue&type=template&id=845d5296&scoped=true"
import script from "./NeedAuth.vue?vue&type=script&lang=js"
export * from "./NeedAuth.vue?vue&type=script&lang=js"

import "./NeedAuth.vue?vue&type=style&index=0&id=845d5296&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845d5296"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
